import script from "./EditorUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorUser.vue?vue&type=script&setup=true&lang=ts"

import "./EditorUser.vue?vue&type=style&index=0&id=c6f1e7c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6f1e7c4"]])

export default __exports__